<template>
    <zj-layout-container v-loading="loading" :element-loading-text="loadingText">
      <zj-layout-header>
        <div class="listtitle">应急预案制定</div>
        <el-form class="zj-search-form" ref="form" :model="form" :label-width="labelWidth">
          <el-form-item style="margin-right:10rem;" label="预案类型">
            <el-select v-model="planType" placeholder="请选择">
              <el-option
                v-for="item in plantypes"
                :key="item.ItemKey"
                :label="item.Extend1"
                :value="item.ItemKey"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item style="margin-right:10rem;" label="事件类型">
            <el-select v-model="eventType" placeholder="请选择">
              <el-option
                v-for="item in fitEventTypes"
                :key="item.ItemKey"
                :label="item.Extend1"
                :value="item.ItemKey"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item style="margin-right:10rem;" label="预案等级">
            <el-select v-model="planLevel" placeholder="请选择">
              <el-option
                v-for="item in eventplanlevels"
                :key="item.ItemKey"
                :label="item.Extend1"
                :value="item.ItemKey"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item style="margin-right:10rem;" label="预案状态">
            <el-select v-model="planstatus" placeholder="请选择">
              <el-option
                v-for="item in planstatuses"
                :key="item.ItemKey"
                :label="item.Extend1"
                :value="item.ItemKey"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item style="margin-right:10rem;" label="预案名称">
            <el-input style="width:21.7rem;" v-model="planName"></el-input>
          </el-form-item>
          <el-form-item label class="right">
            <el-button @click="onSearch">查 询</el-button>
            <el-button @click="onCancel">清 理</el-button>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main style="padding-top:0px;">
        <zj-layout-container>
          <zj-layout-header>
            <div class="zj-button-bar">
              <el-button size="mini" @click="onAdd">添 加</el-button>
              <el-button size="mini" @click="onbatchDel">删 除</el-button>
            </div>
          </zj-layout-header>
          <zj-layout-main style="padding:0.8rem 0px 0px 0px;">
            <el-table
              :data="tableData"
              ref="multipleTable"
              @selection-change="selectionChange"
              border
              style="width: 100%"
              height="100%"
            >
              <el-table-column type="selection" width="55" align="center"></el-table-column>
              <el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
              <el-table-column prop="PlanName" label="预案名称" align="center"></el-table-column>
              <el-table-column prop="PlanNo" label="预案编号" align="center"></el-table-column>
              <el-table-column prop="PlanType" label="预案类型" :formatter="ConvertPlanType" align="center"></el-table-column>
              <el-table-column prop="FitEventType" label="事件类型" :formatter="ConvertFitEventType" align="center"></el-table-column>
              <el-table-column prop="PlanLevel" label="对应级别" :formatter="ConvertPlanLevel" align="center"></el-table-column>
              <el-table-column prop="ProducerName" label="制定人" align="center"></el-table-column>
              <el-table-column prop="PublishDate" label="启用日期" :formatter="formatDate" width="160" align="center"></el-table-column>
              <el-table-column prop="PlanState" label="状态" :formatter="ConvertPlanState" align="center"></el-table-column>
              <el-table-column label="操作" width="130" align="center">
                <template slot-scope="scope">
                  <el-button @click="handleClick(scope.$index,scope.row)" type="text" size="small">查看</el-button>
                  <el-button @click="editClick(scope.$index,scope.row)" type="text" size="small">编辑</el-button>
                  <el-button @click="deleteClick(scope.$index,scope.row)" type="text" size="small">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </zj-layout-main>
        </zj-layout-container>
      </zj-layout-main>
      <zj-layout-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="total"
        ></el-pagination>
      </zj-layout-footer>
    </zj-layout-container>
</template>

<script>
import ZJApp from '../../../../../app';
import MyApis from "../../../apis";
const utils = ZJApp.ZJUtils;
export default {
  name: "ZjPlanList",
  controller: "UI",
  action: "PlanList",
  data() {
    return {
      loading: false,
      loadingText: '加载中...',
      currentPage: 1,
      pageSize: 20,
      total: 0,
      tableData: [],
      plantypes: [],
      plantypedic: [],
      planType: "",
      fitEventTypes: [],
      fitEventTypedic: [],
      eventType: "",
      eventplanlevels: [],
      eventplanleveldic: [],
      planLevel: "",
      planstatuses: [],
      planstatusdic: [],
      planstatus: "",
      planName: "",
      selectData: null,
      dialogOpts: {
        dialogTableVisible: false,
        rowlist: null,
        dialogTable2Visible: false,
        rowlist2: null
      }
    };
  },
  created: function() {
    this.basedatabind()
    .then(()=>{
      this.search();
    });
    this.logInfo.ActionName = "应急预案查看";
    this.logInfo.LogMessage = "应急预案查看";
    this.logInfo.ModuleName = "应急系统";
    this.logInfo.PageName = "应急预案制定列表页面";
    this.addOperationLog();
  },
  methods: {
    // 弹出一个错误消息
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox"
      });
    },
    //基础数据绑定
    basedatabind() {
      this.loading = true;
      this.loadingText = '加载中...';
      return utils.waitAll([
        this.config.getUValue("EmergencyService:EmergencyPlanType:", ""),  //预案类型
        this.config.getUValue("EmergencyService:FitEventType:", ""),       //适用事件类型
        this.config.getUValue("EmergencyService:EventPlanLevel:", ""),     //应对等级
        this.config.getUValue("EmergencyService:EmergencyPlanStatus:", "") //预案状态
      ])
      .then(r => {

        this.plantypes = r[0].JValue;
        for(let i = 0; i < this.plantypes.length; i++) {
          let item=this.plantypes[i];
          this.plantypedic[item.ItemKey]=item.Extend1;
        } 

        this.fitEventTypes = r[1].JValue;
        for(let i = 0; i < this.fitEventTypes.length; i++) {
          let item=this.fitEventTypes[i];
          this.fitEventTypedic[item.ItemKey]=item.Extend1;
        }
        
        this.eventplanlevels = r[2].JValue;
        for(let i = 0; i < this.eventplanlevels.length; i++) {
          let item=this.eventplanlevels[i];
          this.eventplanleveldic[item.ItemKey]=item.Extend1;
        }
        
        this.planstatuses = r[3].JValue;
        for(let i = 0; i < this.planstatuses.length; i++) {
          let item=this.planstatuses[i];
          this.planstatusdic[item.ItemKey]=item.Extend1;
        }
        
        this.loading = false;

        return r;
      })
      .catch(e => {
        console.error(e);
        this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        this.loading = false;
      });
    },
    // 表格的选中 可以获得当前选中的数据
    selectionChange(val) {
      // 将选中的数据存储起来
      this.selectData = val;
      this.dialogOpts.rowlist = val;
      this.dialogOpts.rowlist2 = val;
    },
    search() {
      let searchInfo = {
        PageSize: this.pageSize,
        PageIndex: this.currentPage,
        TotalCount: 0,
        StartNumber: 0,
        EndNumber: 0,
        PlanType:this.planType,
        FitEventType:this.eventType,
        PlanLevel:this.planLevel,
        PlanState:this.planstatus,
        PlanName:this.planName
      };
      this.loading = true;
      this.loadingText = '加载中...';
      new MyApis.PlanApi()
        .GetPageContentByConditions(searchInfo)
        .then(r => {
          r = r.data.Data;
          this.tableData = r.PageContents;
          this.total = r.BaseSearch.TotalCount;
          this.loading = false;
        })
        .catch(e => {
          console.error(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          this.loading = false;
        });
    },
    clearsearch() {
      this.planType = "";
      this.eventType = "";
      this.planLevel = "";
      this.planstatus = "";
      this.planName = "";
    },
    // 点击查询按钮
    onSearch() {
      this.currentPage = 1;
      this.search();
    },
    // 点击取消按钮
    onCancel() {
      this.clearsearch();
      this.search();
    },
    //编辑按钮
    editClick(index, row) {
      this.$router.push({
        path: "/plugin/emergency/ui/PlanManage",
        query: {
          obj: row.PlanId,
          type: "edit"
        }
      });
    },
    //查看详细
    handleClick(index, row) {
      //console.log(index, row);
      this.$router.push({
        path: "/plugin/emergency/ui/PlanManage",
        query: {
          obj: row.PlanId,
          type: "search"
        }
      });
    },
    //添加
    onAdd() {
      this.$router.push({
        path: "/plugin/emergency/ui/PlanManage",
        query: {
          obj: null,
          type: "edit"
        }
      });
    },
    onbatchDel() {
      if (this.selectData != undefined) {
        this.$confirm("选中的数据将被永久删除, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            const selectData = this.selectData;
            const count = selectData.length;
            // 清除 所有勾选项
            this.$refs.multipleTable.clearSelection();
            if (count > 0) {
              this.loading = true;
              this.loadingText = '删除中...';
              new MyApis.PlanApi()
                .DelItemList(selectData)
                .then(r => {
                  r = r.data.Data;
                  if (r) {
                    this.$message({
                      type: "success",
                      message: "删除成功!"
                    });
                  } else {
                    this.$message({
                      type: "error",
                      message: "删除失败!"
                    });
                  }
                  this.loading = false;
                  this.logInfo.ActionName = "应急预案删除";
                  this.logInfo.LogMessage = r ? "应急预案删除成功" : "应急预案删除失败";
                  this.logInfo.ModuleName = "应急系统";
                  this.logInfo.PageName = "应急预案制定列表页面";
                  this.addOperationLog();
                  this.search();
                })
                .catch(e => {
                  console.error(e);
                  this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
                  this.loading = false;
                });
            }
          });
      } else {
        this.$message({
          type: "info",
          message: "未选中任何行！"
        });
      }
    },
    //行删除
    deleteClick(index, row) {
      this.$confirm("此操作将永久删除该行数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.loading = true;
          this.loadingText = '删除中...';
          new MyApis.PlanApi()
            .DelItem(row)
            .then(r => {
              r = r.data.Data;
              if (r) {
                this.$message({
                  type: "success",
                  message: "删除成功!"
                });
              } else {
                this.$message({
                  type: "error",
                  message: "删除失败!"
                });
              }
              this.loading = false;
              this.logInfo.ActionName = "应急预案删除";
              this.logInfo.LogMessage = r ? "应急预案删除成功" : "应急预案删除失败";
              this.logInfo.ModuleName = "应急系统";
              this.logInfo.PageName = "应急预案制定列表页面";
              this.addOperationLog();
              this.search();
            })
            .catch(e => {
              console.error(e);
              this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
              this.loading = false;
            });
        });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
    //日期列表展示格式
    formatDate(row, column) {
      // 获取单元格数据
      let data = row[column.property];
      if (data == null || data == "0001-01-01T00:00:00") {
        return null;
      }
      return new Date(data).format('yyyy-MM-dd hh:mm:ss');
    },
    dialogOk() {
      this.dialogOpts.dialogTableVisible = false;
    },
    dialogCancel() {
      this.dialogOpts.dialogTableVisible = false;
    },
    dialogOk2() {
      this.dialogOpts.dialogTable2Visible = false;
    },
    dialogCancel2() {
      this.dialogOpts.dialogTable2Visible = false;
    },
    ConvertPlanLevel(row, column) {
      let data = row[column.property];
      if (data == null) {
        return null;
      }
      let typestr=this.eventplanleveldic[data];
      return    typestr;
    },
    ConvertPlanType(row, column) {
      let data = row[column.property];
      if (data == null) {
        return null;
      }
      let typestr=this.plantypedic[data];
      return    typestr;
    },
    ConvertFitEventType(row, column) {
      let data = row[column.property];
      if (data == null) {
        return null;
      }
      let typestr=this.fitEventTypedic[data];
      return    typestr;
    },
    ConvertPlanState(row, column) {
      let data = row[column.property];
      if (data == null) {
        return null;
      }
     let typestr=this.planstatusdic[data];
      return    typestr;
    },
  }
};
</script>